var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'attendance-menu-container': true, hidden: !_vm.opened }},[(!_vm.customFormEdit)?_c('FormSelect'):_vm._e(),_c('Groups')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }